import { render, staticRenderFns } from "./CanvasInvite.vue?vue&type=template&id=5153e3d5&"
import script from "./CanvasInvite.vue?vue&type=script&lang=js&"
export * from "./CanvasInvite.vue?vue&type=script&lang=js&"
import style0 from "./CanvasInvite.vue?vue&type=style&index=0&id=5153e3d5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports